import { Input, InputProps } from '@rebass/forms';
import React, { useId } from 'react';
import { Button } from 'rebass';
import colors from '../../theme/colors';
import Icon from '../Icon/Icon';
import { FormComboGroup } from './FormComboGroup';

interface PasswordInputProps extends InputProps {
  showPassword?: boolean;
  toggleShowPassword?: any;
}

const PasswordInput = (props: PasswordInputProps): JSX.Element => {
  const { showPassword, toggleShowPassword } = props;
  const id = useId();

  return (
    <FormComboGroup ml={props.ml}>
      <Input
        id={id}
        type={showPassword ? 'text' : 'password'}
        variant="inputRoundedLeft"
        {...(props as any)}
        ml={undefined}
      />
      <Button
        variant={`forms.inputRoundedRight`}
        type={`button`}
        tabIndex={0}
        aria-label={showPassword ? `Hide password` : `Show password`}
        aria-controls={id}
        display={`flex`}
        alignItems="center"
        justifyContent="center"
        minWidth={36}
        width={36}
        mt={props.mt}
        px={0}
        py={5}
        onClick={() => toggleShowPassword()}
      >
        <Icon
          icon={showPassword ? 'eye-open' : 'eye-slash'}
          color={colors.fieldBorderHover}
          size="16"
        />
      </Button>
    </FormComboGroup>
  );
};

export { PasswordInput };
